export const baseUrl = "https://api.nobalab.com";
// export const baseUrl = "http://localhost:3030";
export const header = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
  "X-Content-Type-Options": "nosniff",
  "X-XSS-Protection": "1",
};
